require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./auto-login-on-startup.json") })
        }
      }, "path---auto-login-on-startup");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---auto-login-on-startup!./.cache/json/auto-login-on-startup.json
// module id = 368
// module chunks = 231608221292675